import { render, staticRenderFns } from "./DivisionPop.vue?vue&type=template&id=98eb2ac0&scoped=true&"
import script from "./DivisionPop.vue?vue&type=script&lang=js&"
export * from "./DivisionPop.vue?vue&type=script&lang=js&"
import style0 from "./DivisionPop.vue?vue&type=style&index=0&id=98eb2ac0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eb2ac0",
  null
  
)

export default component.exports